import axios from '../../../api.service'

export default {
  async fetchProductById({ dispatch, commit }, slug) {
    return await axios.get(`frontend/product/${slug}`)
  },
}
